import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { imagemURL } from "../../../services/variables";
import styles from "../../../styles/module/carousel-image-news.module.css";
import { MdFullscreen } from "react-icons/md";

export default function CarouselImageNews({ img }) {
  const [index, setIndex] = useState(0);
  const [zoomImg, setZoomImg] = useState(null);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const handleZoomIconClick = () => {
    setZoomImg(img[index]);
  };

  const handleCloseZoom = () => {
    setZoomImg(null);
  };

  return (
    <>
      {img[0] !== null && (
        <div className={styles.carouselWrapper}>
          <Carousel
            activeIndex={index}
            onSelect={handleSelect}
            touch={true}
            interval={null}
          >
            {img.map((item, i) => (
              <Carousel.Item key={i}>
                <img
                  className="d-block w-100 w-100-newsImgs"
                  src={imagemURL + item}
                  alt="First slide"
                  style={{ cursor: "zoom-in" }}
                  onClick={() => setZoomImg(item)}
                />
              </Carousel.Item>
            ))}
          </Carousel>
          <MdFullscreen
            onClick={handleZoomIconClick}
            className={styles.zoomIcon}
            title="Ver em zoom"
          />
        </div>
      )}

      {zoomImg && (
        <div className={styles.zoomModal} onClick={handleCloseZoom}>
          <img
            src={imagemURL + zoomImg}
            alt="Imagem ampliada"
            className={styles.zoomImg}
          />
        </div>
      )}
    </>
  );
}
